export default __webpack_public_path__ + "static/media/mprjlogoCompleto.b6b9c704.png";